import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fundacion-page',
  templateUrl: './fundacion-page.component.html',
  styleUrls: ['./fundacion-page.component.scss']
})
export class FundacionPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
